<div class="main-page cadastros journey-main">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Relatório Entrada e Saída da Cerca</h1>
      </div>
    </div>
    <div
      style="
        background-color: #1e3f7a;
        padding: 10px 20px;
        border-radius: 4px;
        margin-bottom: 20px;
      "
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div>
        <button mat-button (click)="onOpenDialogFilter()" style="color: white">
          <mat-icon style="color: white">filter_list</mat-icon>
          Filtrar
        </button>
      </div>
      <div>
        <button
          mat-stroked-button
          (click)="exportExcel()"
          style="color: white; border-color: white; margin-right: 10px"
        >
          <mat-icon style="color: white">table_view</mat-icon>
          Excel
        </button>
        <button
          mat-stroked-button
          (click)="exportPdf()"
          style="color: white; border-color: white"
        >
          <mat-icon style="color: white">picture_as_pdf</mat-icon>
          PDF
        </button>
      </div>
    </div>

    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <!-- COMECA -->
        <p-table
          #journeyheader
          [value]="this.resultadoAnalitico"
          tableStyleClass="tableAnalitico"
        >
          <ng-template pTemplate="header" let-columns>
            <tr
              [hidden]="this.resultadoAnalitico.length == 0"
              [ngClass]="this.filterDialog == true ? '' : 'sticky-top'"
            >
              <th style="text-align: center !important; border: none">Data</th>
              <th style="text-align: center !important; border: none">Placa</th>
              <th style="text-align: center !important; border: none">Frota</th>
              <th style="text-align: center !important; border: none">
                Motorista
              </th>
              <th style="text-align: center !important; border: none">
                Tipo de Movimentação
              </th>
              <th style="text-align: center !important; border: none">
                Nome Cerca
              </th>
              <th style="text-align: center !important; border: none">
                Localização Cerca
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowdata>
            <tr>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px !important;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["dataTexto"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["placa"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["frota"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["motoristaNome"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["tipoCerca"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["nomeCerca"] }}
              </td>
              <td
                style="
                  text-align: center !important;
                  border: none;
                  font-size: 16px;
                  padding: 10px;
                "
                align="center"
                valign="middle"
              >
                <span
                  class="alerta mr-2"
                  data-title="Visualizar"
                  matTooltip="Visualizar"
                >
                  <a (click)="abrirMapaDialog(rowdata)" class="btn btn-link">
                    <img height="20" src="assets/img/view.svg" alt="" />
                  </a>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- FIM-->
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<p-sidebar [(visible)]="this.filterDialog" position="right">
  <div style="margin-bottom: 20px">
    <span>Filtros</span>
  </div>
  <form [formGroup]="this.consultaFormGroup">
    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Início</mat-label>
          <input
            formControlName="dataInicio"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Inicio"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Fim</mat-label>
          <input
            formControlName="dataFim"
            type="datetime-local"
            step="1"
            matInput
            placeholder="Fim"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-checkbox
          style="margin-left: 2%"
          color="primary"
          formControlName="buscaPorEmpresa"
          (change)="onToggleBuscaPorEmpresa()"
        >
          Busca por Empresa
        </mat-checkbox>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select
            formControlName="selecaoEmpresa"
            [(value)]="empresaFilterSelected"
            [(ngModel)]="empresaFilterSelected"
            (selectionChange)="this.filterCompanyReports()"
          >
            <mat-option
              *ngFor="let type of companiesSelect"
              [value]="type.name"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Matriz/Divisão/Filial</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlEmpresa"
            [matAutocomplete]="autoEmpresa"
            required
          />
          <mat-autocomplete
            #autoEmpresa="matAutocomplete"
            [displayWith]="displayEmpresa"
          >
            <mat-option
              *ngFor="let type of this.companiesFilter"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field
      appearance="outline"
      *ngIf="
        !consultaFormGroup.get('buscaPorEmpresa')?.value &&
        controlEmpresa.value != ''
      "
    >
      <mat-label>Placa / Frota</mat-label>
      <input
        type="text"
        matInput
        [formControl]="controlVeiculo"
        [matAutocomplete]="autoTerminal"
      />
      <mat-autocomplete
        #autoTerminal="matAutocomplete"
        [displayWith]="displayTerminal"
      >
        <mat-option
          *ngFor="let type of this.vehiclesFiltered | async"
          [value]="type"
        >
          {{ type.cdPlaca }}/{{ type.frota }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="form-row">
      <div class="form-group col-md-8">
        <!-- [disabled]="!this.lastAnswers[this.lastAnswers.length -1].msg && !this.finalizar" class="ml-1" mat-flat-button color="primary" (click)="onSave()" -->
        <button type="submit" (click)="onConsultar()">Consultar</button>
      </div>
    </div>
  </form>
</p-sidebar>
